import styled from "styled-components";

const Container = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
`;

const Text = styled.p`
  font-weight: bold;
  font-size: 24px;
  font-family: signika, sans-serif;
  color: rgb(0, 99, 169);
  white-space: nowrap;
`;

const Divider = styled.div`
  border-top: 4px dotted rgb(0, 99, 169);
  width: 100%;
  margin-top: 13px;
  margin-bottom: 20px;
`;

export default function TextDotDivider({text}) {
  return (<Container>
    <Text>{text}</Text>
    <Divider/>
  </Container>);
}
